  export function formatWoche(woche: any, format = 'with-year' ) {
    const call_date = new Date();
    const dayspan = 60 * 60 * 24 * 1000 ;
    const weekstart_valueOf = call_date.valueOf() - ( call_date.getDay() - 1 ) * dayspan + woche * 7 * dayspan ; 
    const date = new Date( weekstart_valueOf ) ; 
    const date_ende = new Date( weekstart_valueOf + 6 * dayspan ) ;

    if( format === 'ISO-Date' ) return date.toISOString().split( 'T')[ 0 ] + ' - ' + date_ende.toISOString().split( 'T')[ 0 ] ; 

    let date_format: any =  {
      day: "2-digit",
      month: "2-digit"
    } ;

    if( format === 'with-year' ) date_format.year = '2-digit' ;

    return (
      date.toLocaleDateString("de-DE", date_format ) +
      " - " +
      date_ende.toLocaleDateString("de-DE", date_format )
    );
  }
